__turbopack_context__.v({
  "className": "hanken_grotesk_f06938cf-module__BsHhfa__className",
  "variable": "hanken_grotesk_f06938cf-module__BsHhfa__variable",
});
